import { counsellorConstants } from '../constants';
import { counsellorService } from '../../services';
import Swal from 'sweetalert2';
import { history } from '../../helpers/history';

export const counsellorActions = {
	getCounsellorStatus,
	getCounsellorDetails,
	getCounsellorProfile,
	getCounsellorPublicProfile,
	getMultiCounsellor
};

function getCounsellorProfile(id) {
	return (dispatch) => {
		dispatch(request());
		counsellorService
			.counsellorProfile(id)
			.then((res) => {
				if (res && res.error)//(Object.keys(res).indexOf('error') > -1) 
          dispatch(failure(res));
				else dispatch(success(res));
				
			})
	};
	function request() {
		return { type: counsellorConstants.GET_COUNSELLOR_PROFILE_REQUEST };
	}
	function success(counsellorProfile) {
		return {
			type: counsellorConstants.GET_COUNSELLOR_PROFILE_SUCCESS,
			counsellorProfile,
		};
	}
	function failure() {
		Swal.fire({
			title: 'Saaya Health',
			text: 'Counsellor profile not found',
			icon: 'error',
		})//.then(() =>
		history.replace('/');
		return { type: counsellorConstants.GET_COUNSELLOR_PROFILE_FAILURE };
	}
}
function getCounsellorPublicProfile(id) {
	return (dispatch) => {
		dispatch(request());
		counsellorService
			.counsellorpublicProfile(id)
			.then((res) => {
				if (res && res.error)//(Object.keys(res).indexOf('error') > -1) 
          dispatch(failure(res));
				else dispatch(success(res));
				
			})
	};
	function request() {
		return { type: counsellorConstants.GET_COUNSELLOR_PROFILE_REQUEST };
	}
	function success(counsellorProfile) {
		return {
			type: counsellorConstants.GET_COUNSELLOR_PROFILE_SUCCESS,
			counsellorProfile,
		};
	}
	function failure() {
		Swal.fire({
			title: 'Saaya Health',
			text: 'Counsellor profile not found',
			icon: 'error',
		})//.then(() =>
		history.replace('/notfound');
		return { type: counsellorConstants.GET_COUNSELLOR_PROFILE_FAILURE };
	}
}
function getCounsellorStatus() {
	return (dispatch) => {
		dispatch(request());
		counsellorService.counsellorStatus().then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: counsellorConstants.GET_COUNSELLOR_STATUS_REQUEST };
	}
	function success(counsellorStatus) {
		return {
			type: counsellorConstants.GET_COUNSELLOR_STATUS_SUCCESS,
			counsellorStatus,
		};
	}
	function failure(counsellorStatus) {
		return { type: counsellorConstants.GET_COUNSELLOR_STATUS_FAILURE, counsellorStatus };
	}
}

function getCounsellorDetails(counsellorId) {
	return (dispatch) => {
		dispatch(request());
		counsellorService.counsellorDetails(counsellorId).then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: counsellorConstants.GET_COUNSELLOR_DETAILS_REQUEST };
	}
	function success(counsellorDetails) {
		return {
			type: counsellorConstants.GET_COUNSELLOR_DETAILS_SUCCESS,
			counsellorDetails,
		};
	}
	function failure(counsellorDetails) {
		return { type: counsellorConstants.GET_COUNSELLOR_STATUS_FAILURE, counsellorDetails };
	}
}

function getMultiCounsellor() {
	return (dispatch) => {
		dispatch(request());
		counsellorService.fetchMultiCounselor().then(
			(data) => dispatch(success(data)),
			(error) => dispatch(failure(error.toString()))
		);
	};
	function request() {
		return { type: counsellorConstants.GET_MULTI_COUNSELLOR_REQUEST };
	}
	function success(multiCounsellor) {
		return {
			type: counsellorConstants.GET_MULTI_COUNSELLOR_SUCCESS,
			multiCounsellor,
		};
	}
	function failure(multiCounsellor) {
		return { type: counsellorConstants.GET_MULTI_COUNSELLOR_FAILURE, multiCounsellor };
	}
}



// WEBPACK FOOTER //
// ./src/store/actions/counsellor.actions.js